import { useKeycloak as useKeycloakWeb } from "@react-keycloak/web";
import axios from "axios";

export function useKeycloak() {
  const { keycloak, initialized } = useKeycloakWeb();
  const sessionToken = sessionStorage.getItem("login-token");

  if (sessionToken) {
    axios.interceptors.request.use((config: any) => {
      config.headers.Authorization = `Bearer ${sessionToken}`;
      return config;
    });

    return {
      jwtToken: sessionToken,
      keycloakUserState: "authorize",
      authorize: true,
      fetchKeycloakLogout: () => keycloak.logout(),
      fetchKeycloakLogin: () => keycloak.login(),
    };
  }

  return {
    jwtToken: keycloak.token,
    keycloakUserState: initialized
      ? keycloak.authenticated
        ? "authorize"
        : "guest"
      : "init",
    authorize: keycloak.authenticated,
    fetchKeycloakLogout: () => keycloak.logout(),
    fetchKeycloakLogin: () => keycloak.login(),
  };
}
